import React, {useState} from 'react'
import { Form, Button, FloatingLabel, Col } from 'react-bootstrap';
import Axios from 'axios';
import { useNavigate } from 'react-router-dom';

export default function PassEditForm(props) {

    const [newUser, setNewUser] = useState(props.currentUser)

    let navigate = useNavigate();

    const editPass = (journal) => {
        Axios.put("auth/password", journal, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            console.log(response)
            props.handleSuccessMessage("Password Updated Successfully!")
            navigate("/profile/detail", { replace: true });
        })
        .catch(error => {
            props.handleErrorMessage("Error Updating Password!")
            console.log(error)
        })
    }

    const handleChange = (event) =>{
        const attributeToChange = event.target.name
        const newValue = event.target.value
    
        const user = {...newUser}
        user[attributeToChange] = newValue
        
        setNewUser(user)
        // console.log("user", newUser)
    }
    
    const handleSubmit = (event) => {
        event.preventDefault();
        editPass(newUser);
        event.target.reset();
    }
    
    
    return (
        <div>
            <h1>Change Password</h1>

            <Form onSubmit={handleSubmit}>
            <Col xs={10} sm={4} className="center-form">
            <FloatingLabel controlId="floatingInput4" label="Current password" className="mb-3">
                <Form.Control type="password" name="passwordConfirm" placeholder="Current password" onChange={handleChange} value={newUser.password}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingTextarea2" label="New password" className="mb-3">
                <Form.Control type="password" name="newPassword" minlength="6" placeholder="New password" onChange={handleChange} value={newUser.newPassword}></Form.Control>
            </FloatingLabel>
            <FloatingLabel controlId="floatingInput5" label="Confirm new password" className="mb-3">
                <Form.Control type="password" name="newPasswordConfirm" minlength="6" placeholder="Confirm new password" onChange={handleChange} value={newUser.newPasswordConfirm}></Form.Control>
            </FloatingLabel>
            <Button variant="dark" type="submit" value="Save" onClick={props.onHide}>Save</Button>&nbsp;
            <Button variant="link text-dark" onClick={() => navigate(-1)}>Back</Button>
            </Col>
        </Form>
        </div>
    )
}
